import { render, staticRenderFns } from "./carIdentify.vue?vue&type=template&id=29ba4bf4&scoped=true&"
import script from "./carIdentify.vue?vue&type=script&lang=js&"
export * from "./carIdentify.vue?vue&type=script&lang=js&"
import style0 from "./carIdentify.vue?vue&type=style&index=0&id=29ba4bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ba4bf4",
  null
  
)

export default component.exports